import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from "../../actions";
import { Card } from 'antd';
import {filter_rates_by_carrier} from "../../actions";

const FilterRates = (props) => {
    const [finalCarrier, setFinalCarrier] = useState([]);
    const [selectedCarrier, setSelectedCarrier] = useState('');


    useEffect(() => {
        // Whenever selected_carrier changes from Redux store, update local state
        if (props.selected_carrier && props.selected_carrier !== '') {
            setSelectedCarrier(props.selected_carrier);
        } else {
            // Reset local state if selected_carrier in Redux is empty
            setSelectedCarrier('');
        }
    }, [props.selected_carrier]);  // Dependency array to watch selected_carrier
    

    useEffect(() => {
        const finalRatesGroupByCarrier = [];
        // Check if filteredJson exists and has length > 0, else fallback to fcl
        const ratesToUse = (props.seaFCLJSON?.rates?.filteredJson && props.seaFCLJSON.rates.filteredJson.length > 0) 
        ? props.seaFCLJSON.rates.filteredJson 
        : props.seaFCLJSON?.rates?.fcl;
    
        if (ratesToUse) {
            ratesToUse.forEach((object, index) => {
                if (index === 0) {
                    finalRatesGroupByCarrier.push(object);
                } else {
                    const hasSealine = finalRatesGroupByCarrier.some(
                        (carrier) => carrier.sealine === object.sealine
                    );
                    if (!hasSealine) {
                        finalRatesGroupByCarrier.push(object);
                    }
                }
            });
        }
        setFinalCarrier(finalRatesGroupByCarrier);
    }, [props.seaFCLJSON]);

const blockRate=(event)=>{
    const selectedValue = event.target.value;
    if (selectedValue === selectedCarrier) {
        setSelectedCarrier('');
        props.setSelectedCarrier('');
    } else {
        setSelectedCarrier(selectedValue);
        props.setSelectedCarrier(selectedValue);
    }
    props.filter_rates_by_carrier(event.target.value,event.target.checked)
}


    return (
        <>
            <Card
                className="role-container-type testBlu1"
                bordered={false}
                style={{
                    height: 'auto',
                }}
            >
                <h4
                    style={{
                        color: '#43637c',
                        fontWeight: '500',
                        fontSize: '16px',
                        marginBottom: '8px',
                    }}
                    className="testR1"
                >
                    Filter Rates By Carrier
                </h4>

                {finalCarrier.map((object, index) => (
                    <label key={index} style={{ display: 'block' }}>
                        <input
                            type="checkbox"
                            value={object.sealine}
                            onClick={blockRate}
                            checked={selectedCarrier === object.sealine}
                            disabled={selectedCarrier !== "" && selectedCarrier === object.sealine}
                        />
                        &nbsp;{object.sealine}
                    </label>
                ))}
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        final_search_form: state.route.final_search_form,
        isExistingPickupFactorySelected: state.form.pickup.selectedExistingFactoryJson,
        isExistingDeliveryFactorySelected: state.form.delivery.selectedExistingFactoryJson,
        AgentInformation: state.form.AgentInformation,
        queryParams: state.route.queryParams,
        originalRateData: state.route.originalRateData,
        seaFCLJSON:state.route.seaFCLJSON,
        selected_carrier: state.route.selected_carrier
    };
};

export default connect(mapStateToProps, actions)(FilterRates);
